export default "__VITE_ASSET__yfewdi6J__"